import * as React from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {PageContainer} from "../app/atoms/PageContainer";
import {MainPage} from "../app/components/MainPage";
import {IStore} from "../app/reducers/hybrid_reducer";
import {RequestState} from "../app/utils/request_response_utils/factories/reduce_request_state";
import {CarBox} from "../offer/detail/components/car_box/CarBox";
import {getOfferCardImage} from "../offer/utils/get_offer_card_image";
import {ISellerOffer} from "./actions/fetch_seller_offers_at_route";
import {SellerHero} from "./components/SellerHero";

export const SellerDynamic = () => {
    const seller = useSelector((store: IStore) => store.seller.data);
    const requestState = useSelector((store: IStore) => store.seller.requestState);

    if (requestState === RequestState.Waiting || !seller) {
        return (
            <MainPage>
                <PageContainer>
                    <p css={statusText}>Ładowanie ofert sprzedawcy…</p>
                </PageContainer>
            </MainPage>
        );
    }

    const locationLine = [seller.city, seller.wojew ? `woj. ${seller.wojew}` : null].filter(Boolean).join(", ");
    const stockPreviewImages = seller.offers
        .map(getOfferCardImage)
        .filter(Boolean)
        .filter((url, index, all) => all.indexOf(url) === index)
        .slice(0, 3);

    return (
        <MainPage>
            <PageContainer>
                <div css={pagePad}>
                    <SellerHero
                        name={seller.name}
                        locationLine={locationLine || undefined}
                        offerCount={seller.offers.length}
                        description={seller.description}
                        coverUrl={seller.cover_url}
                        coverKey={seller.cover_key}
                        logoUrl={seller.logo_url}
                        logoKey={seller.logo_key}
                        stockPreviewImages={stockPreviewImages}
                        addressStreet={seller.address_street}
                    />

                    <h2 css={offersHeading}>Oferty sprzedawcy</h2>
                    <div css={gridStyle}>
                        {seller.offers.map((car) => {
                            const acf = car.acf || ({} as ISellerOffer["acf"]);
                            const slug = car.slug || String(car.id || "");
                            if (!slug) {
                                return null;
                            }
                            return (
                                <CarBox
                                    key={car.id}
                                    id={car.id}
                                    brand={acf.make}
                                    model={acf.model}
                                    year={parseInt(String(acf.year || ""), 10) || 0}
                                    mileage={parseInt(String(acf.millage || "0").replace(/\s/g, ""), 10) || 0}
                                    price={parseInt(String(acf.price || "0").replace(/\s/g, ""), 10) || 0}
                                    image={getOfferCardImage(car)}
                                    slug={slug}
                                    listName="seller_page"
                                />
                            );
                        })}
                    </div>
                </div>
            </PageContainer>
        </MainPage>
    );
};

const pagePad = css`
    padding: 1rem 1rem 0;

    @media (min-width: 1230px) {
        padding-left: 0;
        padding-right: 0;
    }
`;

const offersHeading = css`
    margin: 0 0 1rem;
    font-size: 18px;
    font-weight: 700;
    color: #333;
`;

const statusText = css`
    padding: 3rem 1rem;
    color: #66676c;
`;

const gridStyle = (theme: Theme) => css`
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr;
    padding-bottom: 3rem;

    @media (min-width: ${theme.breakpoints.screen_xxs}) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: ${theme.breakpoints.screen_xs}) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: ${theme.breakpoints.screen_md}) {
        grid-template-columns: repeat(4, 1fr);
    }
`;
